// removed by extract-text-webpack-plugin
module.exports = {"drugContainer":"_25OnYY2SpZPDpn_VswCr3H","drugInfoContainer":"_95chTGTnx5JF4-bfXpv-Q","formContainer":"_1kV-HIi507iVWFjr1bVIM_","cancelButton":"gIvwAGGT8lr2-RRsnFpgG","question3":"_5cXPERkWrFZo7nKaacVDa","radioButton":"_3YyFlJmdHZ-01Qbk6bAT6J","screenResults":"_1J40itZ7mVPmvCiI_cZoRs","notes":"_2RNothFH66z0y26-giYxVy","overrideCheckbox":"_2T29M1UoYBfGvqQrC90BU6","modalTable":"VR9EVJzTi8577X-vO272N"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/DrugDispenser.scss
// module id = 224
// module chunks = 0